import { AfterViewInit, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { SpiderChartAxis } from '@shared/models/step.model';
import { ChartConfiguration } from 'chart.js';
import { Breakpoint, WindowEventService } from '@shared/services/window.event.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'pl-spider-chart',
  templateUrl: './spiderChart.component.html',
})
export class SpiderChartComponent implements OnInit, AfterViewInit {
  @Input() public title: string = '';
  @Input({ required: true }) public axes: SpiderChartAxis[] = [];

  public radarChartLabels: string[] = [];

  public radarChartOptions: ChartConfiguration<'radar'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      r: {
        min: 0,
        max: 100,
        pointLabels: {
          font: {
            family: 'Montserrat, Helvetica, Roboto, Arial, sans-serif',
            size: 14,
          },
          color: '#333333', // pl-text-gray-700
          display: true, // Show the labels around the radar chart
          callback: (label: string, index: number): string => `${label} (${this.axes[index].value}%)`,
        },
        ticks: {
          count: 5,
          display: false, // Hides the labels in the middle (numbers)
        },
      },
    },
  };

  public radarChartDatasets: ChartConfiguration<'radar'>['data']['datasets'] = [];
  private destroyRef: DestroyRef = inject(DestroyRef);

  public tailwindHeightClass: string = 'h-[450px]';

  constructor(private windowEventService: WindowEventService) {
    this.windowEventService
      .getWindowResizeEvent()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((screenSize: number) => {
        if (screenSize > Breakpoint.sm) {
          this.tailwindHeightClass = 'h-[450px]';
        } else {
          this.tailwindHeightClass = 'h-[250px]';
        }
      });
  }

  public ngOnInit(): void {
    this.radarChartLabels = this.axes.map((axis: SpiderChartAxis): string => {
      return axis.axis;
    });
    this.radarChartDatasets = this.getChartDataSet(this.axes);
  }

  private getChartDataSet(axes: SpiderChartAxis[]): ChartConfiguration<'radar'>['data']['datasets'] {
    return [
      {
        data: axes.map((axis: SpiderChartAxis): number => {
          return +axis.value;
        }),
        fill: true,
        backgroundColor: 'rgba(31, 119, 180, 0.7)',
        borderColor: 'rgb(31, 119, 180)',
        pointBackgroundColor: 'rgb(31, 119, 180, 0.9)',
        pointBorderColor: 'rgb(31, 119, 180, 0.9)',
        pointHoverBackgroundColor: 'rgb(31, 119, 180)',
        pointHoverBorderColor: 'rgb(31, 119, 180)',
        borderWidth: 1,
      },
    ];
  }

  public ngAfterViewInit(): void {}
}
